export default "__VITE_ASSET__yGbdrcKy__"